import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useAppDispatch } from 'state/hooks';
import {
  setDraftState,
  useGetUserSubscriptionsQuery,
} from 'state/userAdminSlices';

import { useSubscription } from 'features/common/hooks/useSubscription';
import { MapContextProvider } from 'features/map/MapContext';
import { FloatingLoadingSpinner } from 'features/spinner/Spinner';
import { UserProjectsPanel } from 'features/user_admin/UserProjectsPanel';

import { ProjectDetailPage } from './ProjectDetail';
import { UserProjectRequestEdit } from './UserProjectRequestEdit';
import { useUprStatus } from './hooks';

export function UserProjectRequestPage() {
  const { currentData: subscriptionData } = useGetUserSubscriptionsQuery();
  const { upr_id } = useParams();
  const dispatch = useAppDispatch();
  const { subscription } = useSubscription();
  const { isNew: isNewUPR, isEditable: isEditableUPR } = useUprStatus();
  const template = subscription?.template;
  const upr_data =
    !isNewUPR &&
    subscription &&
    subscription.project_requests.filter((upr) => upr.hash_id === upr_id)[0];

  useEffect(() => {
    if (!isNewUPR && subscriptionData) {
      dispatch(
        setDraftState({
          subscription_id: subscription.subscription_id,
          project_name: upr_data.project_name,
          boundary: upr_data.boundary,
          hash_id: upr_data.hash_id,
          project_end: upr_data.project_end,
          special_date_requests: upr_data.special_date_requests,
        }),
      );
    }
  }, [upr_id, subscriptionData]);

  let content = <FloatingLoadingSpinner />;
  if (subscription) {
    content = isEditableUPR ? (
      <UserProjectRequestEdit template={template} subscription={subscription} />
    ) : (
      <ProjectDetailPage project_data={upr_data} subscription={subscription} />
    );
  }

  return (
    <UserProjectsPanel>
      <MapContextProvider>{content}</MapContextProvider>
    </UserProjectsPanel>
  );
}
